import * as $ from "jquery";
import * as Backbone from "backbone";
import * as Marionette from "backbone.marionette";
import {on, debounce, Options} from "../utils/decorators";
import * as Cookies from 'js-cookie';

@Options({
    template: false,
    ui: {
        acceptButton: "[data-js-ui=accept-button]",
    },
})
export default class HelpscoutView extends Marionette.View<Backbone.Model>{
    element: HTMLElement;

    constructor(options?:object) {
        super(options);

        let el = (this.$el as any);
    }


    onRender() {
        const interval = setInterval(() => {
            // console.log('looking for helpscout...');
            if ('Beacon' in window && document.querySelector('#beacon-container')) {
                clearInterval(interval);
            }
        }, 100);

        // setTimeout(() => {
        //     // couldn't find helpscout within 10 seconds, it's
        //     // probably not gonna load
        //     clearInterval(interval);
        // }, 1000 * 10)
    }
}



// WEBPACK FOOTER //
// ./@modules/views/helpscout-view.ts